import {
  BUSINESS_TYPE_EDIT, BUSINESS_TYPE_EDIT_FAILURE, BUSINESS_TYPE_EDIT_SUCCESS, BUSINESS_TYPE_UPDATE, BUSINESS_TYPE_UPDATE_FAILURE, BUSINESS_TYPE_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    business_type: null
  },
  getters: {
    edit_business_type: state => {
      return state.business_type
    }
  },
  actions: {
    [BUSINESS_TYPE_EDIT] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var callback = null
      if (data) {
        callback = params.callback
      }
      var url = '/master/business_types/' + params.id
      dispatch('apiGet', {url: url, data: data, loadparams: true})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(BUSINESS_TYPE_EDIT_FAILURE, res.data)
            } else {
              res.data.callback = callback
              commit(BUSINESS_TYPE_EDIT_SUCCESS, res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [BUSINESS_TYPE_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/master/business_types/' + params.id
      dispatch('apiPatch', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(BUSINESS_TYPE_UPDATE_FAILURE, res.data)
            } else {
              commit(BUSINESS_TYPE_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [BUSINESS_TYPE_EDIT_FAILURE] (state, data) {
      console.log('BUSINESS_TYPE_EDIT_FAILURE')
    },
    [BUSINESS_TYPE_EDIT_SUCCESS] (state, data) {
      console.log('BUSINESS_TYPE_EDIT_SUCCESS')
      state.business_type = data
      if (data.callback) {
        data.callback()
      }
    },
    [BUSINESS_TYPE_UPDATE_FAILURE] (state, data) {
      console.log('BUSINESS_TYPE_UPDATE_FAILURE')
    },
    [BUSINESS_TYPE_UPDATE_SUCCESS] (state, data) {
      console.log('BUSINESS_TYPE_UPDATE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/businesstype-edit.js